export const ADD_USER_SALARY_CONDITIONS = "ADD_USER_SALARY_CONDITIONS";
export const GET_USER_SALARY_CONDITIONS = "GET_USER_SALARY_CONDITIONS";
export const SET_USER_SALARY_CONDITIONS = "SET_USER_SALARY_CONDITIONS";
export const DELETE_USER_SALARY_CONDITIONS = "DELETE_USER_SALARY_CONDITIONS";
export const UPDATE_USER_SALARY_CONDITIONS = "UPDATE_USER_SALARY_CONDITIONS";

export const LOADER_USER_SALARY_CONDITIONS = "LOADER_USER_SALARY_CONDITIONS";